import React, { useState } from 'react';
import { Modal, Button, Table, Spinner } from 'react-bootstrap';
import { FaWindowClose, FaPaperPlane } from 'react-icons/fa';
import { toast } from 'react-toastify';
import moment from 'moment';
import { efetivarLancamentoIPTU } from '~/Services/GestaoIPTUService';
import { extrairMensagemErro } from '~/Utils/Helpers';

// D4 Fluxo 3 — Tela de revisão do lançamento de Débitos IPTU
// (uDebitosIPTU.dfm — Notebook1.nbLancaChave + RxDBGrid2).
//
// Espelha as 13 colunas do grid Delphi (linhas 603-767 do .dfm). O usuário
// revisa cada despesa antes de gravar em Contas_aPagar. Botão "Lançar"
// confirma e grava; "Sair" descarta a preparação.
const ModalRevisaoLancamentoIPTU = ({ show, onHide, onLancado, token, despesas }) => {
  const [lancando, setLancando] = useState(false);

  const lista = Array.isArray(despesas) ? despesas : [];

  const fmtMoeda = (v) =>
    v == null
      ? '—'
      : Number(v).toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

  const fmtData = (v) => (v ? moment(v).format('DD/MM/YYYY') : '—');

  const handleLancar = async () => {
    if (!token) {
      toast.error('Token de lançamento ausente.');
      return;
    }
    if (!window.confirm('Deseja lançar as chaves?')) return;

    setLancando(true);
    try {
      const resp = await efetivarLancamentoIPTU(token);
      const lancados = (resp && resp.lancados) || 0;
      const avisos = (resp && resp.avisos) || [];
      if (lancados > 0) {
        toast.success(`Registros lançados com sucesso (${lancados}).`);
      }
      avisos.forEach((aviso) => toast.warning(aviso));
      if (onLancado) onLancado();
    } catch (err) {
      toast.error(extrairMensagemErro(err));
    } finally {
      setLancando(false);
    }
  };

  const handleSair = () => {
    if (lancando) return;
    if (!window.confirm('Deseja sair sem lançar as chaves?')) return;
    onHide();
  };

  return (
    <Modal show={show} onHide={handleSair} size="xl" backdrop="static" dialogClassName="modal-95w">
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 18 }}>
          Lançamento de Chaves de Pagamento
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ overflowX: 'auto' }}>
          <Table bordered hover size="sm" style={{ fontSize: 11, marginBottom: 0, whiteSpace: 'nowrap' }}>
            <thead>
              <tr>
                <th style={{ color: '#001f5b' }}>GE</th>
                <th style={{ color: '#001f5b' }}>Fornecedor</th>
                <th style={{ color: '#001f5b' }}>Despesa</th>
                <th style={{ color: '#001f5b' }}>Departamento</th>
                <th style={{ color: '#001f5b' }}>Favorecido</th>
                <th style={{ color: '#001f5b' }}>Cód. Contábil</th>
                <th style={{ color: '#001f5b', textAlign: 'right' }}>Valor</th>
                <th style={{ color: '#001f5b' }}>Vencimento</th>
                <th style={{ color: '#001f5b' }}>Tipo</th>
                <th style={{ color: '#001f5b' }}>Observação</th>
                <th style={{ color: '#001f5b' }}>Texto</th>
                <th style={{ color: '#001f5b' }}>Linha Digitável</th>
                <th style={{ color: '#001f5b' }}>Manter Na Caixa de Aprovação</th>
              </tr>
            </thead>
            <tbody>
              {lista.length === 0 ? (
                <tr>
                  <td colSpan={13} className="text-center text-muted py-3">
                    Nenhuma despesa preparada.
                  </td>
                </tr>
              ) : (
                lista.map((d, idx) => (
                  <tr key={`${d.codigo_ativo}-${idx}`}>
                    <td>{d.codigo_grupo_empresa}</td>
                    <td>{d.fornecedor_desc}</td>
                    <td>{d.despesas_desc}</td>
                    <td>{d.departamento_desc}</td>
                    <td>{d.favorecido_desc}</td>
                    <td>{d.codigo_contabil}</td>
                    <td style={{ textAlign: 'right' }}>{fmtMoeda(d.valor)}</td>
                    <td>{fmtData(d.vencimento)}</td>
                    <td>{d.modalidade_desc}</td>
                    <td title={d.observacao}>{d.observacao}</td>
                    <td title={d.texto} style={{ maxWidth: 280, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {d.texto}
                    </td>
                    <td style={{ fontFamily: 'monospace', fontSize: 10 }}>{d.barras}</td>
                    <td>{d.manter_na_caixa_aprovacao_desc}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="success"
          onClick={handleLancar}
          disabled={lancando || lista.length === 0}
          className="d-inline-flex align-items-center"
          style={{ minWidth: 160 }}
        >
          {lancando ? (
            <Spinner animation="border" size="sm" className="mr-2" />
          ) : (
            <FaPaperPlane className="mr-2" />
          )}
          Lançar
        </Button>
        <Button
          variant="light"
          onClick={handleSair}
          disabled={lancando}
          className="d-inline-flex align-items-center"
          style={{ minWidth: 160 }}
        >
          <FaWindowClose />
          <span className="ml-2">Sair</span>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalRevisaoLancamentoIPTU;
